$(document).ready(function () {
    'use strict';
    let gMapsLoaded = false;
    const loadGMaps = () => {
        $.getScript('https://maps.googleapis.com/maps/api/js?key=AIzaSyCpmbakDjQTwNrSSb6fVSFMbmB9Zqir8Zo', () => {
            gMapsLoaded = true
        });
    }

    if (matchesMediaQuery(768)) {
        $('.js_newItemTabsMenu li:first-child').addClass('active');
        $('.js_newItemTabs .newItemTab:first-child').addClass('active');

        $('.js_newItemTabsMenu--ev li:first-child').addClass('active');
        $('.js_newItemTabs--ev .newItemTab:first-child').addClass('active');
    }

    $('.summaryCtaButton').on('click', function(event) {
        event.preventDefault();

        let dataTab = $(this).data('tab');

        // tabs
        if (matchesMediaQuery(768)) {
            let tabsMenu = $('.js_newItemTabsMenu'),
                menuItem = tabsMenu.find('li[data-tab="' + dataTab +'"] > a');

            // if we find the menu item
            if (menuItem.length > 0) {

                // scroll to tabs
                $('body, html').stop(true, false).animate({
                    scrollTop: tabsMenu.offset().top - 30
                }, 400);

                // trigger a click
                menuItem.trigger('click')
            }
        } else {
            // accordions
            let accordions = $('.js_newItemTabs'),
                accordionItem = accordions.find('.newItemTab[data-tab=' + dataTab +']');

            if (accordionItem.length > 0) {
                // get title
                let accordionItemTitle = accordionItem.find('.newItemTabTitle > a');

                // scroll to tabs
                $('body, html').stop(true, false).animate({
                    scrollTop: accordions.offset().top - 30
                }, 400);

                // trigger a click
                accordionItemTitle.trigger('click')
            }
        }
    });

    $(document).on('click', '.js_newItemTabsMenu a', function(e) {

        if (matchesMediaQuery(768)) {
            e.preventDefault();

            if ($(this).closest('li').data('tab') === 'delivery-cost' && gMapsLoaded !== true) {
                loadGMaps()
            }

            $('.js_newItemTabsMenu > li').removeClass('active');
            $(this).closest('li').addClass('active');

            $('.js_newItemTabs .newItemTab').removeClass('active');

            $('.js_newItemTabs .newItemTab').eq($(this).closest('li').index()).addClass('active');
        }
    })

    $(document).on('click', '.js_newItemTabs .newItemTabTitle', function(e) {
        if (matchesMediaQuery(0,767)) {
            e.preventDefault();

            if ($(this).closest('.newItemTab').data('tab') === 'delivery-cost' && gMapsLoaded !== true) {
                loadGMaps()
            }

            $(this).toggleClass('active');

            $('.js_newItemTabs .newItemTab').eq($(this).closest('.newItemTab').index()).toggleClass('active');

            if ($(this).next().find('.collapsible h3.open').hasClass('open')) {
                $(this).next().find('.collapsible h3.open').next('.collapsibleContent').show();
            }
        }
    })


});

// todo: This is hacked together atm to quickly use the same styles as item new tabs for EV tabs, these will be changed out once the FPA changes start
const evTabTriggers = document.querySelectorAll('.js_newItemTabsMenu--ev a')
console.log({evTabTriggers})
const evTabs = document.querySelectorAll('.js_newItemTabs--ev .js_newItemTab--ev')
console.log({evTabs})

evTabTriggers.forEach((trigger) => {
    const parent = trigger.closest('li')
    if (!parent) {
        return
    }

    const tab = parent.getAttribute('data-tab')

    trigger.addEventListener('click', (e) => {
        e.preventDefault();
        // change active class for menu
        [...evTabTriggers].map((x) =>
            x.parentNode.dataset.tab === tab
                ? x.parentNode.classList.add('active')
                : x.parentNode.classList.remove('active')
        );

        // change active class for tabs
        [...evTabs].map((x) =>
            x.dataset.tab === tab
                ? x.classList.add('active')
                : x.classList.remove('active')
        );
    });
});

const evTabTitleTriggers = document.querySelectorAll('.js_newItemTab--ev .newItemTabTitle');

evTabTitleTriggers.forEach((t) => {
    const parent = t.closest('.js_newItemTab--ev');
    if (!parent) return;

    const tab = parent.getAttribute('data-tab');
    if (!tab) return;

    t.addEventListener('click', (e) => {
        e.preventDefault();

        t.closest('.newItemTabTitle').classList.toggle('active');
        parent.classList.toggle('active');
    });
});
